import React, { FunctionComponent, useMemo } from 'react';
import { INodeHeaderProps } from './types';
import { CircularAvatar } from '../../../../common/CustomAvatar';

export const NodeHeader: FunctionComponent<INodeHeaderProps> = ({ nodeData, userData }) => {
  const userName = useMemo(() => (userData ? `${userData.firstName} ${userData.lastName || ''}`.trim() : undefined), [
    userData,
  ]);
  const nodeTitle = useMemo(() => nodeData.nodeTitle, [nodeData.nodeTitle]);

  return (
    <>
      <div className="orgchart-box-img small-avatar">
        {userData && userName && <CircularAvatar title={userName} src={userData.image} />}
      </div>
      <div className="orgchart-box-title">
        <h5>{nodeTitle}</h5>
        {userName ? <h6>{userName}</h6> : <h6>Vacant</h6>}
      </div>
    </>
  );
};
